import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { pauseInspectionService } from '../../api/inspection-service.ts';

export default function usePauseInspectionService(): UseMutationResult<
  Awaited<ReturnType<typeof pauseInspectionService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => pauseInspectionService(serviceId),
  });
}
